
import { z } from "zod";

export const EscrowVendorValues = ["PAY_KEEPER"] as const;
export const EscrowVendorSchema = z.enum(EscrowVendorValues);
export const EscrowVendor = EscrowVendorSchema.enum;
export type EscrowVendor = (typeof EscrowVendorValues)[number];
export const EscrowVendorDisplayNames = { "PAY_KEEPER": "Pay Keeper", } satisfies Record<EscrowVendor, string>;
